module.exports = __webpack_public_path__ + "static/media/ortho-icon@3x.57969496.png";